import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePageMeta } from "@/lib/seo";
import ProductCard from "@/components/shop/ProductCard";
import { AgeGate, hasAdultConsent } from "@/components/AgeGate";

export default function AdultPage() {
  usePageMeta({
    title: "Adult (18+) | IPVALUE Marketplace",
    description: "Adults-only department. 18+ required.",
  });
  const [ok, setOk] = useState(hasAdultConsent());
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!ok) return;
    api
      .get("/products", { params: { category: "Adult (18+)", include_adult: true, limit: 60 } })
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]));
  }, [ok]);

  if (!ok) return <AgeGate onConfirm={() => setOk(true)} />;

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-8 py-10" data-testid="adult-page">
      <div className="ipv-eyebrow text-[#C9971E]">Discreet · Adults only</div>
      <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tighter text-[#0A1C40] mt-1">
        Adult (18+)
      </h1>
      <p className="text-sm text-gray-600 mt-2 max-w-xl">
        Everything ships and is handed over in plain, unmarked packaging. This section never appears in
        site search or the homepage.
      </p>
      {items === null ? (
        <div className="py-20 text-center text-gray-500">Loading…</div>
      ) : items.length === 0 ? (
        <div className="py-20 text-center text-gray-500" data-testid="adult-empty">
          Nothing here yet — check back soon.
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mt-8">
          {items.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
